import moment from 'moment';

const ENCTags = (doc, data, clinica, IVA, typeDocumentInvoice) => {
    var ENC = doc.createElement("ENC");

    //Tipo de Documento (INVOIC, ND, NC)
    var ENC_1 = doc.createElement("ENC_1");
    ENC_1.innerHTML = typeDocumentInvoice == "INVOICE" ? "INVOIC" : "NC";
    ENC.appendChild(ENC_1);

    //NIT de la Clinica
    var ENC_2 = doc.createElement("ENC_2");
    ENC_2.innerHTML = clinica.nit.split("-")[0];
    ENC.appendChild(ENC_2);

    //NIT o Cedula del FACTURADO (Adquiriente)
    var ENC_3 = doc.createElement("ENC_3");
    ENC_3.innerHTML = data.detalles_comerciales.cliente.num_document;
    ENC.appendChild(ENC_3);

    //Version de esquema UBL
    var ENC_4 = doc.createElement("ENC_4");
    ENC_4.innerHTML = "UBL 2.1";
    ENC.appendChild(ENC_4);

    //Version del Formato ante la DIAN
    var ENC_5 = doc.createElement("ENC_5");
    ENC_5.innerHTML = "DIAN 2.1";
    ENC.appendChild(ENC_5);

    //Prefijo y Consecutivo de la Factura
    var ENC_6 = doc.createElement("ENC_6");
    ENC_6.innerHTML = typeDocumentInvoice == "INVOICE" ? data.num_fac_ter.replace('-', '') : data.detallesReferenciaFactura.num_nota_credito;
    ENC.appendChild(ENC_6);

    //Fecha de Emisión de la Factura
    var ENC_7 = doc.createElement("ENC_7");
    ENC_7.innerHTML = moment(data.fecha_emision).format("YYYY-MM-DD");
    ENC.appendChild(ENC_7);

    //Hora de Emisión de la Factura
    var ENC_8 = doc.createElement("ENC_8");
    ENC_8.innerHTML = moment(data.fecha_emision).format("HH:mm:ss");
    ENC.appendChild(ENC_8);

    //Codigo de Documento ante la DIAN (01 - FACTURA, 91 - NOTA CREDITO, 92- NOTA DEBITO)
    var ENC_9 = doc.createElement("ENC_9");
    ENC_9.innerHTML = typeDocumentInvoice == "INVOICE" ? "01" : "91";
    ENC.appendChild(ENC_9);

    //Moneda de la FACTURA
    var ENC_10 = doc.createElement("ENC_10");
    ENC_10.innerHTML = "COP";
    ENC.appendChild(ENC_10);

    /*
    //Periodo Inicial (Fecha Inicio corte de Facturación)
    var ENC_11 = doc.createElement("ENC_11");
    ENC_11.innerHTML = data.fecha_inicial != null && data.fecha_inicial != undefined ? moment(data.fecha_inicial).format("YYYY-MM-DD") : "";
    ENC.appendChild(ENC_11);

    //Periodo Final (Fecha Final corte de Facturación)
    var ENC_12 = doc.createElement("ENC_11");
    ENC_12.innerHTML = data.fecha_final != null && data.fecha_final != undefined ? moment(data.fecha_final).format("YYYY-MM-DD") : "";
    ENC.appendChild(ENC_12);
    */

    //Número de Lineas o Items en el Documento
    var ENC_15 = doc.createElement("ENC_15");
    ENC_15.innerHTML = data.items.items.length;
    ENC.appendChild(ENC_15);

    //Fecha de Vencimiento
    var ENC_16 = doc.createElement("ENC_16");
    ENC_16.innerHTML = data.vencimiento != null && data.vencimiento != undefined ? moment(data.vencimiento).format("YYYY-MM-DD") : "";
    ENC.appendChild(ENC_16);

    //URL para enviar archivos Anexos
    var ENC_17 = doc.createElement("ENC_17");
    ENC_17.innerHTML = 'sftp://warescolombia.net';
    ENC.appendChild(ENC_17);

    //URL para PAGOS
    var ENC_18 = doc.createElement("ENC_18");
    ENC_18.innerHTML = 'www.warescolombia.net';
    ENC.appendChild(ENC_18);

    //Ambiente de la Factura (1 Produccion, 2 Pruebas)
    var ENC_20 = doc.createElement("ENC_20");
    ENC_20.innerHTML = 2;
    ENC.appendChild(ENC_20);

    //Documento (FE (10) si NC (20)  si ND (30))
    var ENC_21 = doc.createElement("ENC_21");
    ENC_21.innerHTML = typeDocumentInvoice == "INVOICE" ? 10 : 20;
    ENC.appendChild(ENC_21);

    return ENC;
}

export default ENCTags;